/* global isProcurementPlanAvailable */

import React from 'react';

import ProcurementPlanIndex from '../../procurement_plan/ProcurementPlanIndex';
import { useProcurement } from '../context/ProcurementContext';

const ProcurementPlanTab = () => {
    const { routes, settings } = useProcurement();

    // The procurement plan only exists on the evolving budget version. When a locked / non-evolving
    // budget is being viewed the data endpoints redirect, so we must not mount the index (which would
    // fire requests that resolve to HTML and crash the tab). Show an explanatory message instead.
    if (typeof isProcurementPlanAvailable !== 'undefined' && !isProcurementPlanAvailable) {
        return <div className="tw-text-center tw-text-charcoal-50 tw-py-12">{$t('The procurement plan is only available on the latest budget version.')}</div>;
    }

    return (
        <ProcurementPlanIndex
            prEnabled={settings.isPrEnabled}
            eaEnabled={settings.isEaEnabled}
            directCommitEnabled={settings.isDirectCommitEnabled}
            fetchUrl={routes.fetchProcurementPlanUrl}
            expensesUrl={routes.fetchExpensesUrl}
            storePRUrl={routes.storePRUrl}
            indexPRUrl={routes.indexPRUrl}
            directCommitmentUrl={routes.directCommitmentUrl}
            directPurchaseOrderUrl={routes.directPurchaseOrderUrl}
            draftsIndexUrl={routes.draftsIndexUrl}
            deleteDraftUrl={routes.deleteDraftUrl}
            refreshCommitmentDataUrl={routes.refreshCommitmentDataUrl}
            syncProcurementPlanProjectsUrl={routes.syncProcurementPlanProjectsUrl}
            fetchDepartmentsUrl={routes.fetchDepartmentsUrl}
            storeProcurementPlanItemUrl={routes.storeProcurementPlanItemUrl}
            listUsersUrl={routes.listUsersUrl}
            eventStartDate={settings.eventStartDate}
            eventEndDate={settings.eventEndDate}
        />
    );
};

export default ProcurementPlanTab;
